import { FC, ReactNode, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ProfileButton } from '../../components';
import { useUserStore } from '../../stores';
import { UserRole } from '../../utils';
import { Container, PageContent, ProfileAside, ProfilePages, SectionTitle, Separator, ToggleButton } from './Reports.styles';

interface ReportsProps {
	children: ReactNode;
}

const adminPages = [
	{
		name: 'Dashboard',
		path: '/relatorios',
	},
	{
		name: 'Anúncios',
		path: '/relatorios/admin-anuncios-interno',
	},
	{
		name: 'Concessionárias',
		path: '/relatorios/admin-concessionarias-interno',
	},
	{
		name: 'Lojistas',
		path: '/relatorios/admin-lojistas-interno',
	},
	{
		name: 'Vendas',
		path: '/relatorios/admin-vendas-interno',
	},
	{
		name: 'Pagamentos',
		path: '/relatorios/admin-pagamentos-interno',
	},
	{
		name: 'Inadimplentes',
		path: '/relatorios/admin-pagamentos-inadimplentes',
	},
	{
		name: 'Revendas Sem Compras',
		path: '/relatorios/admin-revendas-sem-compras',
	},
	{
		name: 'Revendas que Atrasam Pagtos',
		path: '/relatorios/admin-compradores-atrasam-pagamentos',
	}
];

const lookerPages = [
	{
		name: 'Anúncios',
		path: '/relatorios/admin-anuncios',
	},
	{
		name: 'Vendas',
		path: '/relatorios/admin-vendas',
	},
	{
		name: 'Concessionárias',
		path: '/relatorios/admin-concessionarias',
	},
	{
		name: 'Lojistas',
		path: '/relatorios/admin-lojistas',
	},
	{
		name: 'Usuários',
		path: '/relatorios/admin-usuarios',
	},
	{
		name: 'Canal vs Avaliador',
		path: '/relatorios/admin-canal-avaliador',
	},
	{
		name: 'Pagamentos',
		path: '/relatorios/admin-pagamentos',
	}
];

const dealerPages = [
	{
		name: 'Tempo Médio de Vendas',
		path: '/relatorios',
	},
	{
		name: 'Vendas',
		path: '/relatorios/vendas-concessionaria',
	}
];

const Reports: FC<ReportsProps> = ({ children }) => {
	const { user } = useUserStore();
	const location = useLocation();
	const [subPages, setSubPages] = useState(adminPages);
	const [subExternalPages, setExternalSubPages] = useState(lookerPages);
	const [collapsed, setCollapsed] = useState(false);

	useEffect(() => {
		if (user?.grupoAcesso.id.toString() === UserRole.Dealer) {
			setSubPages(dealerPages);
			setExternalSubPages([]);
		}

		if (user?.grupoAcesso.id.toString() === UserRole.Admin) {
			setSubPages(adminPages);
			setExternalSubPages(lookerPages);
		}
	}, [user?.grupoAcesso.id]);

	return (
		<Container collapsed={collapsed}>
			<ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
				{collapsed ? '>>': '<<' }
			</ToggleButton>
			<ProfileAside collapsed={collapsed}>
				{!collapsed &&
				<>
					<Container>
						<SectionTitle>Relatórios Sintéticos</SectionTitle>
					</Container>
					<ProfilePages>
						{subPages.map((page) => (
							<Link style={{ width: '100%' }} to={page.path} key={page.name}>
								<ProfileButton
									label={page.name}
									active={page.path === location.pathname}
								/>
							</Link>
						))}
						{subExternalPages.length > 0 && (
							<>
								<Separator />
								<Container>
									<SectionTitle>Relatórios Analíticos</SectionTitle>
								</Container>
								{subExternalPages.map((page) => (
									<Link style={{ width: '100%' }} to={page.path} key={page.name}>
										<ProfileButton
											label={page.name}
											active={page.path === location.pathname}
										/>
									</Link>
								))}
							</>
						)}
					</ProfilePages>
				</>
				}
			</ProfileAside>
			<PageContent collapsed={collapsed}>{children}</PageContent>
		</Container>
	);
};

export default Reports;
